import React from "react";
import "./TodoLoading.css"

function TodoLoading(){
    return(
        <div className="TodoLoading"></div>
    )
}

export {TodoLoading}